import { mediacoreApi } from '../mediacoreApi'

const is_compiler = process.env.GATSBY_IS_SITE_COMPILER === 'true'
const CLIENT_ID = process.env.GATSBY_CLIENTID

const summarySiteExtended = mediacoreApi.injectEndpoints({
  endpoints: (builder) => ({
    getSummarySite: builder.query({
      query: (SITE_ID) => ({
        url: `core/summary/${CLIENT_ID}${is_compiler ? '?site=' + SITE_ID : ''}`,
        // url: `core/summary/${CLIENT_ID}`,
        // method: 'POST',
        // body: { site: SITE_ID },
      }),
    }),
  }),
  overrideExisting: false,
})

export const { useGetSummarySiteQuery } = summarySiteExtended
